import React from 'react';
import { View, ScrollView } from 'react-native';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { VFScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PermissionsDescriptionSection, PermissionsItem } from '../../../CommonUI';
import { ConfirmButton, SuccessModal } from '../../Components';

import PERMISSIONS_KEYS from './PERMISSIONS_KEYS';
import styles from './PersonalPreferences.Styles';

class PersonalPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.intialToggleState = {
      basicToggle: false,
      advancedToggle: false,
    };
    this.state = {
      confirmDisabled: true,
      ...this.intialToggleState,
      advancedToggleChildren: {},
      singleTogglesList: {},
    };
    this.driveToggleStatesFromProps(props);
  }
  componentDidUpdate(__, prevState) {
    this.updateConfirmButton();
    if (!_.isEqual(prevState.advancedToggleChildren, this.state.advancedToggleChildren)) {
      this.handleAvancedToggleChildren();
    }
  }
  driveToggleStatesFromProps(props) {
    function reduce(toggleProps) {
      return toggleProps.reduce((obj, item) => Object.assign(obj, { [item.title]: false }), {});
    }
    const advancedToggleChildren = reduce(props.advancedPermissionChildren);
    const singleTogglesList = reduce(props.singlePermissionsList);
    this.intialToggleState = {
      ...this.intialToggleState,
      advancedToggleChildren,
      singleTogglesList,
    };
    this.state = {
      ...this.state,
      advancedToggleChildren,
      singleTogglesList,
    };
  }
  updateConfirmButton = () => {
    const { confirmDisabled, ...toggleStates } = this.state;
    if (!confirmDisabled && _.isEqual(toggleStates, this.intialToggleState)) {
      this.setState({ confirmDisabled: true });
    } else if (confirmDisabled && !_.isEqual(toggleStates, this.intialToggleState)) {
      this.setState({ confirmDisabled: false });
    }
  };
  handleAvancedToggleChildren = () => {
    const isChildrenOff = Object.values(this.state.advancedToggleChildren).every(
      value => value === false,
    );
    if (isChildrenOff) {
      this.setState({ advancedToggle: false });
      this.props.onPermissionChange({ key: PERMISSIONS_KEYS.ADVANCED, value: false });
    }
  };
  toggleAdvanced = () => {
    if (!this.props.isBasicDependant || this.state.basicToggle) {
      this.setState(prevValue => {
        return { advancedToggle: !prevValue.advancedToggle };
      });
      const newState = { ...this.state.advancedToggleChildren };
      this.props.advancedPermissionChildren
        .map(array => array.title)
        .map(key => {
          newState[key] = !this.state.advancedToggle;
          this.props.onPermissionChange({ key: key, value: newState[key] });
        });
      this.setState({ advancedToggleChildren: newState });
      this.props.onPermissionChange({
        key: PERMISSIONS_KEYS.ADVANCED,
        value: !this.state.advancedToggle,
      });
    }
  };
  toggleBasic = () => {
    this.props.onPermissionChange({
      key: PERMISSIONS_KEYS.BASIC,
      value: !this.state.basicToggle,
    });
    if (this.props.isBasicDependant && this.state.basicToggle && this.state.advancedToggle) {
      this.toggleAdvanced();
    }
    this.setState(prevValue => {
      return { basicToggle: !prevValue.basicToggle };
    });
  };
  toggleAdvancedChild = key => {
    if (this.state.advancedToggle) {
      this.setState({
        advancedToggleChildren: {
          ...this.state.advancedToggleChildren,
          [key]: !this.state.advancedToggleChildren[key],
        },
      });
      this.props.onPermissionChange({
        key: key,
        value: !this.state.advancedToggleChildren[key],
      });
    }
  };
  toggleSinglePermission = key => {
    this.setState({
      singleTogglesList: {
        ...this.state.singleTogglesList,
        [key]: !this.state.singleTogglesList[key],
      },
    });
    this.props.onPermissionChange({
      key: key,
      value: !this.state.singleTogglesList[key],
    });
  };

  renderAdvancedPermissionChildren = () => {
    return (
      <>
        {this.props.advancedPermissionChildren.map(permission => {
          return (
            <PermissionsItem
              key={permission.title}
              style={styles.advancedPermissionsChildStyle(this.props.theme)}
              descriptionStyle={styles.advancedPermissionsChildTextStyle(this.props.theme)}
              title={permission.title}
              description={permission.description}
              renderDescription={permission.renderDescription}
              initialValue={this.state.advancedToggleChildren[permission.title] ?? false}
              onAcceptanceChange={() => this.toggleAdvancedChild(permission.title)}
            />
          );
        })}
      </>
    );
  };

  renderSinglePermissionsList = () => {
    return (
      <>
        {this.props.singlePermissionsList.map((permission, index) => {
          return (
            <View
              key={permission.title}
              style={styles.permissionCardView(
                this.props.theme,
                index === this.props.singlePermissionsList.length - 1,
              )}
            >
              <PermissionsItem
                style={styles.singlePermissionItemStyle}
                descriptionStyle={styles.permissionDescriptionStyle(this.props.theme)}
                title={permission.title}
                icon={permission.icon}
                images={this.props.images}
                description={permission.description}
                renderDescription={permission.renderDescription}
                initialValue={this.state.singleTogglesList[permission.title] ?? false}
                onAcceptanceChange={() => this.toggleSinglePermission(permission.title)}
              />
            </View>
          );
        })}
      </>
    );
  };

  render() {
    return (
      <VFScreen
        title="personal_preferences_title"
        showBack
        onBack={this.props.onBack}
        containerStyle={styles.VFScreenStyle}
        onClose={this.props.onClose}
        withHeaderSpace
      >
        <ScrollView contentContainerStyle={styles.contentContainer}>
          <VFText i18nKey={this.props.subTitle} style={styles.subTitleStyle} />

          <View style={styles.learnMoreDescriptionContainer}>
            <PermissionsDescriptionSection
              textColor={this.props.theme.colors.text.primaryGrey}
              section={this.props.descriptionSection}
            />
          </View>

          <View style={styles.permissionCardView(this.props.theme)}>
            <PermissionsItem
              key={PERMISSIONS_KEYS.BASIC}
              style={styles.singlePermissionItemStyle}
              icon="ic_indicators_admin"
              images={this.props.images}
              descriptionStyle={styles.permissionDescriptionStyle(this.props.theme)}
              title="personal_preferences_basic_toggle_title"
              renderDescription={() => this.props.renderDescription(PERMISSIONS_KEYS.BASIC)}
              description="personal_preferences_basic_description"
              initialValue={this.state.basicToggle}
              onAcceptanceChange={this.toggleBasic}
            />
          </View>

          <View style={styles.permissionCardView(this.props.theme)}>
            <PermissionsItem
              key={PERMISSIONS_KEYS.ADVANCED}
              style={styles.singlePermissionItemStyle}
              icon="ic_indicators_business"
              renderDescription={() => this.props.renderDescription(PERMISSIONS_KEYS.ADVANCED)}
              images={this.props.images}
              descriptionStyle={styles.permissionDescriptionStyle(this.props.theme)}
              title="personal_preferences_advanced_toggle_title"
              description="personal_preferences_advanced_description"
              initialValue={this.state.advancedToggle}
              onAcceptanceChange={this.toggleAdvanced}
            />

            {this.props.advancedPermissionChildren && this.renderAdvancedPermissionChildren()}
          </View>

          {this.props.singlePermissionsList && this.renderSinglePermissionsList()}
        </ScrollView>

        <ConfirmButton
          isConfirmDisabled={this.state.confirmDisabled}
          onConfirm={this.props.onConfirm}
        />

        <SuccessModal {...this.props.successModalProps} />
      </VFScreen>
    );
  }
}

PersonalPreferences.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  descriptionSection: PropTypes.object,
  subTitle: PropTypes.string,
  advancedPermissionChildren: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  singlePermissionsList: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  onPermissionChange: PropTypes.func,
  successModalProps: PropTypes.shape({
    isVisible: PropTypes.bool,
    onPrimaryPress: PropTypes.func,
    onSecondaryPress: PropTypes.func,
  }).isRequired,
  theme: PropTypes.object,
  images: PropTypes.object,
  onBack: PropTypes.func,
  renderDescription: PropTypes.func,
  isBasicDependant: PropTypes.bool,
};
PersonalPreferences.defaultProps = {
  onClose: () => {},
  onConfirm: () => {},
  theme: LightThemeColors,
  onPermissionChange: () => {},
  onBack: () => {},
  renderDescription: () => {},
  isBasicDependant: true,
};

export default withTheme(PersonalPreferences);
